import { MainApi } from "./MainApi";

// 병원 후기 API (자체 후기 DB). provider+placeKey로 병원 식별.
export type HospitalProvider = "NAVER" | "KAKAO" | "GOOGLE";

export interface HospitalReviewPostBody {
  provider: HospitalProvider;
  placeKey: string;
  hospitalName: string;
  roadAddress?: string | null;
  rating: number;
  content: string;
}

export class HospitalReviewApi {
  static baseUrl = `${MainApi.urlPrefix}/user/hospital-review`;

  static createReview = (body: HospitalReviewPostBody) => () =>
    MainApi.api.post(`${HospitalReviewApi.baseUrl}`, body);

  static getReviews = (provider: HospitalProvider, placeKey: string) => () =>
    MainApi.api.get(`${HospitalReviewApi.baseUrl}`, { params: { provider, place_key: placeKey } });

  // 검색 결과 카드용 평점/리뷰수 일괄 집계
  static getSummaries = (provider: HospitalProvider, placeKeys: string[]) => () =>
    MainApi.api.post(`${HospitalReviewApi.baseUrl}/summary`, { provider, placeKeys });
}
